import { AnyAction } from 'redux'
import {
  SAVE_TOTAL_PAGES,
  SAVE_TOTAL_ELEMENTS,
  SAVE_USERS,
  SET_IS_LOADING_USERS,
  UPDATE_CURRENT_PAGE, SAVE_MANAGERS, UPDATE_USER_SUPERVISION_STATUS, UPDATE_LINK_STATUS_FILTER
} from '../actions/usersAction'
import { IS_NOT_AUTHENTICATED } from '../../authorization/actions/security'

const initialState = {
  users: [],
  managers: [],
  totalPages: 0,
  totalElements: 0,
  currentPage: 0,
  linkStatusFilter: 'ALL',
  isLoadingUsers: true
}

const usersTab = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SAVE_USERS:
      return {
        ...state,
        users: action.users
      }
    case SAVE_MANAGERS:
      return {
        ...state,
        managers: action.managers
      }
    case SAVE_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages
      }
    case SAVE_TOTAL_ELEMENTS:
      return {
        ...state,
        totalElements: action.totalElements
      }
    case UPDATE_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage
      }
    case UPDATE_LINK_STATUS_FILTER:
      return {
        ...state,
        linkStatusFilter: action.linkStatusFilter
      }
    case SET_IS_LOADING_USERS:
      return {
        ...state,
        isLoadingUsers: action.isLoadingUsers
      }
    case UPDATE_USER_SUPERVISION_STATUS:
      return {
        ...state,
        users: state.users.map(user =>
          (user.id === action.payload.userId
            ? { ...user, supervision_status: action.payload.newStatus }
            : user)
        )
      }
    case IS_NOT_AUTHENTICATED:
      return initialState
    default:
      return state
  }
}

export default usersTab
